/**
 * Class for handling callring button visibility.
 * Allowed times are inserted to data-attribute, which
 * contains string. String format is "10,18,10,15"
 * where first pair represents weekday opening and closing
 * while second pair is for saturday. Closed on sundays.
 */

class Callring {

  constructor() {
    this.buttonID = 'callring-button';
  }

  init() {
    this.button = document.getElementById(this.buttonID);
    this.allowedTimes = [];
    if (this.button) {
      this.allowedTimes = this.button.dataset.calltimes.split(',').map(v => parseInt(v));
      this.timeChecker();
    }
  }

  timeChecker() {
    const [weekdayOpen, weekdayClose, saturdayOpen, saturdayClose] = this.allowedTimes;
    const currentTime = new Date();
    const currentDay = currentTime.getDay();
    const currentHour = currentTime.getHours();

    // weekday 0 is sunday
    if (currentDay === 0) {
      return;
    }
    // weekday 6 is saturday
    if (currentDay === 6) {
      if (currentHour >= saturdayOpen && currentHour < saturdayClose) {
        this.showButton()
      }
      return;
    }

    if (currentHour >= weekdayOpen && currentHour < weekdayClose) {
      this.showButton()
      return;
    }
  }

  showButton() {
    this.button.classList.remove('d-none');
    this.button.parentElement.classList.add('button-row--fourbuttons')
  }
}

export default Callring;
export { Callring };
